import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1b70d09c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1b70d09c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70d09c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/practice/company-code-box/index.vue
// module id = null
// module chunks = 